import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PmdNavbarModule} from './propeller/navbars/index';
import { PmdSidebarModule } from './propeller/sidebar/index';
import { PmdCollapseModule } from './propeller/collapse/index';
import { PmdDropdownModule } from './propeller/dropdown/index';
import { PmdFormGroupModule } from './propeller/input/index';
import { PmdButtonModule } from './propeller/button/index';
import { PmdCardModule } from './propeller/card/index';
import { PmdSwitchModule } from './propeller/switch/index';
import { PmdAccordionModule } from './propeller/accordion/index';
import { PmdCheckboxModule } from './propeller/checkbox/index';
import { PmdTooltipModule } from './propeller/tooltip/index';
import { PmdAlertModule } from './propeller/alert/index';
import { PmdRippleEffectModule } from './propeller/ripple/index';
import { PmdModalModule} from './propeller/modal/index';
import { PmdRadioButtonModule } from './propeller/radio/index';
import { PmdButtonToggleModule } from './propeller/button-toggle/index';
import { PmdTabsModule } from './propeller/tabs/index';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { PmdDatepickerModule } from './propeller/datepicker';
import {PmdPopoverModule} from './propeller/popover/index';
import { PmdProgressbarModule } from './propeller/progressbar';
import { ToastrModule } from 'ngx-toastr';
import { NgSelectModule } from './propeller/ng-select/public-api';
// import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { BsDatepickerModule } from './propeller/datepicker/index';
import { NotFoundComponent } from './not-found/not-found.component';
import {NouisliderModule } from 'ng2-nouislider';
import { RatingModule } from './propeller';
import { SkipContentDirective } from './directives/skip-content.directive';
import { PageLoaderComponent } from './page-loader/page-loader.component';
import { HelpComponent } from './help/help.component';
import {NgxPaginationModule} from 'ngx-pagination'; // <-- import the module
import { PaginationComponent } from './pagination/pagination.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { ConfirmationPopupComponent } from './confirmation-popup/confirmation-popup.component';
import { PmdEditorModule } from './text-editor/text-editor.module';
import { inputValueTrim } from 'src/app/shared/directives/trim-input-value.directive';
@NgModule({
  declarations: [
    NotFoundComponent,
    SkipContentDirective,
    PageLoaderComponent,
    HelpComponent,
    PaginationComponent,
    DateRangePickerComponent,
    ConfirmationPopupComponent,
    inputValueTrim
  ],
  imports: [
    CommonModule,
    PmdNavbarModule,
    PmdSidebarModule,
    PmdCardModule, 
    PmdCollapseModule.forRoot(), 
    PmdDropdownModule.forRoot(), 
    PmdFormGroupModule.forRoot(), 
    PmdPopoverModule.forRoot(),
    PmdButtonModule, 
    PmdTabsModule.forRoot(),    
    PmdSwitchModule,
    PmdAccordionModule.forRoot(),
    PmdCheckboxModule, 
    PmdTooltipModule.forRoot(), 
    PmdAlertModule.forRoot(), 
    PmdRippleEffectModule,  
    PmdModalModule.forRoot(),
    PmdButtonToggleModule.forRoot(),
    PmdRadioButtonModule,
    PmdProgressbarModule.forRoot(),
    RatingModule.forRoot(),
    // PmdDatepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgSelectModule,
    NouisliderModule,
    NgxPaginationModule,
    CarouselModule,
    PmdEditorModule,
    ReactiveFormsModule
   
  ],
  exports: [
    PmdNavbarModule,
    PmdSidebarModule,
    PmdCardModule, 
    PmdCollapseModule, 
    PmdDropdownModule, 
    PmdFormGroupModule, 
    PmdButtonModule, 
    PmdTabsModule,    
    PmdSwitchModule,
    PmdAccordionModule,
    PmdCheckboxModule, 
    PmdTooltipModule, 
    PmdAlertModule, 
    PmdPopoverModule,
    PmdRippleEffectModule,
    PmdModalModule,
    FormsModule,
    ReactiveFormsModule,
    PmdButtonToggleModule,
    PmdRadioButtonModule,
    PmdProgressbarModule,
    RatingModule,
    // PmdDatepickerModule,
    BsDatepickerModule,
    NgSelectModule,
    TranslateModule,
    NouisliderModule,
    SkipContentDirective,
    PageLoaderComponent,
    HelpComponent,
    PaginationComponent,
    CarouselModule,
    DateRangePickerComponent,
    ConfirmationPopupComponent,
    PmdEditorModule,
    inputValueTrim

  ],
  providers: [],
})
export class SharedModule { }
